import { APIS_INVENTORY } from "@/constants/apis";
import axios from "axios";
import { ref } from "vue";
import { TOKEN } from '@/constants/labels';
import { showConsoleError } from '@/functions/errors'

export async function getAllInventoryData() {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_INVENTORY.value.getAllInventoryData, { headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: any = response.data;
      const finalObj = ref<any[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}
